import { ComponentProps } from 'react';
import { map } from 'lodash/fp';

import { GET_TOC_PERKS } from '../../src/client/models/table-of-contents/queries.gql';
import { getPreviewOptionsFromCookieHeader } from '../../src/client/cms/utils/preview-cookie';
import getCmsData from '../../src/client/cms/utils/get-cms-data';
import getShouldSkipClientSideRequest from '../../src/client/utils/get-should-skip-client-side-request';
import getTableOfContentsItems from '../../src/client/cms/utils/get-table-of-contents-items';
import PerkPage from '../../src/client/pages/perks/listing';
import setCacheControlHeader from '../utils/set-cache-control-header';
import useTableOfContents from '../../src/client/cms/utils/use-table-of-contents';

const PERKS_IDENTIFIER = 'perks-page';

const PerksLandingPage = ({ ...props }: ComponentProps<typeof PerkPage>) => {
  const shouldSkipClientQuery = getShouldSkipClientSideRequest();

  const { items: perksRaw, loading: arePerksLoading } = useTableOfContents({
    query: GET_TOC_PERKS,
    skip: shouldSkipClientQuery,
    slug: PERKS_IDENTIFIER,
    typename: 'MemberPerk',
  });

  if (shouldSkipClientQuery || arePerksLoading) {
    return <PerkPage {...props} />;
  }

  const perks = map('item', perksRaw);
  return <PerkPage perks={perks} />;
};

// @ts-expect-error - Automatic, Please fix when editing this file
export const getServerSideProps = async ({ req, res }) => {
  setCacheControlHeader(res);
  const { dataset, mode } = getPreviewOptionsFromCookieHeader(req.headers.cookie) ?? {};

  const allPerks = await getCmsData(GET_TOC_PERKS, { variables: { identifier: PERKS_IDENTIFIER } }, dataset, mode);
  const perkEntries = getTableOfContentsItems(allPerks, 'MemberPerk');

  return { props: { perks: map('item', perkEntries) } };
};

export default PerksLandingPage;
